export const inventory = {
      title: 'Inventory',
      subtitle: 'Stock by product and warehouse',
      recordsTitle: 'Current stock',
      recordsDescription: 'Review current stock by product and warehouse.',
      adjust: '+ Adjust inventory',
      editLevels: 'Edit levels',
      editLevelsTitle: 'Edit inventory levels',
      editLevelsSubtitle: 'Configure the minimum and maximum inventory for this balance.',
      editLevelsSubtitleWithItem: '{{product}} · {{warehouse}}',
      emptyTitle: 'No stock to display',
      emptyDescription: 'There are no inventory records for the selected view or warehouse.',
      byProduct: 'By product',
      byWarehouse: 'By warehouse',
      warehouse: 'Warehouse',
      allWarehouses: 'All',
      preferredUnitSwitch: 'Unit',
      preferredUnitSwitchHint: 'Converts stock and levels to the product preferred unit.',
      minimumQuantity: 'Minimum inventory',
      maximumQuantity: 'Maximum inventory',
      storedValueHint: 'Current stored value: {{quantity}} {{unit}}',
      maximumMustBeGreaterThanMinimum: 'Maximum inventory must be greater than or equal to minimum inventory.',
      totalBoxes: 'Total boxes',
      productsCount: 'Number of products',
      state: 'Status',
      critical: 'Critical',
      low: 'Low',
      overstock: 'Overstock',
      ok: 'OK',
    } as const;
